// src/components/dashboard/TopBarStats.jsx
import React, { memo } from "react";
/* ─ helpers ─ */
const safeNum = v => Number.isFinite(Number(v)) ? Number(v) : 0;
const fmtHours = v => safeNum(v).toFixed(2);
function Chip({
  icon,
  value,
  label,
  tone = "blue",
  isDark,
  hintTitle
}) {
  // Starke Kontraste für perfekte Lesbarkeit
  const tones = {
    blue: "bg-blue-500/10 text-blue-100 border-blue-400/20",
    amber: "bg-amber-500/10 text-amber-100 border-amber-400/20",
    violet: "bg-violet-500/10 text-violet-100 border-violet-400/20",
    gray: "bg-white/5 text-gray-200 border-white/10"
  };
  const tip = hintTitle || `${label}: ${value}`;
  return <div className={["inline-flex items-center gap-1.5", "h-8 px-3 rounded-lg border", "text-[12px] leading-none whitespace-nowrap", "", tones[tone] || tones.blue].join(" ")} title={tip} aria-label={tip}>
      <span className="text-sm leading-none -mt-[1px]" aria-hidden>{icon}</span>
      <span className="font-bold">{value}</span>
      <span className={"opacity-80"}>{label}</span>
    </div>;
}
function TopMini({
  data
}) {
    const d = data || {};
  const dayActual = fmtHours(d.day?.actual);
  const dayGoal = fmtHours(d.day?.goal);
  const weekActual = fmtHours(d.week?.actual);
  const weekGoal = fmtHours(d.week?.goal);
  const monthActual = fmtHours(d.month?.actual);
  const monthGoal = fmtHours(d.month?.goal);
  const month = `${monthActual} / ${monthGoal} h`;
  const day = `${dayActual} / ${dayGoal} h`;
  const week = `${weekActual} / ${weekGoal} h`;
  return <div className={`rounded-2xl px-3 py-2.5 mb-4 border ${"bg-white/5 border-white/10"}`}>
      {/* Heute / Woche / Monat — gleiche Einheit (Stunden), gleiche Lesart. */}
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Chip icon="🎯" value={day} label="Heute" tone="blue" isDark={true} />
        <Chip icon="📅" value={week} label="Woche" tone="violet" isDark={true} />
        <Chip
          icon="📆"
          value={month}
          label="Monat"
          tone="amber"
          isDark={true}
          hintTitle="Kalendermonat bis heute: gebuchte Stunden vs. Soll (Mo–So der KW kann noch im Vormonat liegen)."
        />
      </div>
    </div>;
}
export default memo(TopMini);